import accepted from '@/assets/images/status/accepted.webp'
import cooking from '@/assets/images/status/cooking.webp'
import near from '@/assets/images/status/near.webp'
import onWay from '@/assets/images/status/on-way.webp'
import ready from '@/assets/images/status/ready.webp'
import { t } from '@/i18n'

/**
 * Карточки о смене статуса заказа («Уведомление / …» в макете): картинка,
 * заголовок и подпись на каждый шаг степпера. Тексты те же, что на экране
 * статуса, — клиент видит одно и то же в уведомлении и в заказе.
 *
 * Собираем функциями, а не константами: подписи должны меняться вместе
 * с языком, а массив на уровне модуля застыл бы на стартовом.
 */
export interface OrderNoticeContent {
  image: string
  title: string
  text: string
}

/** Доставка: принят → готовится → в пути → рядом → доставлен. */
const deliveryNotices = (): OrderNoticeContent[] => [
  { image: accepted, title: t('status.accepted'), text: t('status.acceptedText') },
  { image: cooking, title: t('status.cooking'), text: t('status.cookingText') },
  { image: onWay, title: t('status.onWay'), text: t('status.onWayText') },
  { image: near, title: t('status.near'), text: t('status.nearText') },
  { image: ready, title: t('status.delivered'), text: t('status.deliveredText') },
]

/** Самовывоз короче: принят → готовится → можно забирать. */
const pickupNotices = (): OrderNoticeContent[] => [
  { image: accepted, title: t('status.accepted'), text: t('status.acceptedPickupText') },
  { image: cooking, title: t('status.cooking'), text: t('status.cookingPickupText') },
  { image: ready, title: t('status.ready'), text: t('status.readyText') },
]

export function noticeOf(step: number, isPickup: boolean): OrderNoticeContent | null {
  const list = isPickup ? pickupNotices() : deliveryNotices()
  return list[step] ?? null
}
